import { CustomerList } from '../../modules/customer-management/customer-list/components/CustomerList/CustomerList';

export const CustomerListPage = (): JSX.Element => <CustomerList />;
